<template>
  <div class="Walkintothekingsway">
    <div class="banner">
      <el-image v-if="bannerList[0]" style="width: 100%; height: 100%" :src="bannerList[0].image" :alt="bannerList[0].title" fit="cover" @click="toUrl(bannerList[0].url)"></el-image>
    </div>
    <Noticeontheright></Noticeontheright>
    <!-- 详情 -->
    <div class="content">
      <el-tabs tab-position="left">
        <el-tab-pane label="报名前必读须知">
          <div id="notice" class="con_item notice">
            <div class="item_tit">报名前必读须知</div>
            <div class="details_box">
              <div class="intro">
                <div class="title">
                  {{noticeList.title}}
                </div>
                <div class="text" v-html="noticeList.note">

                </div>
              </div>
              <div class="problem">
                <div class="item" v-for="(item,index) in problemList" :key="index">
                  <div class="title">Q{{ index + 1 }}：{{ item.problem }}</div>
                  <div class="text" v-html="item.content"></div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="学习生活环境">
          <div id="environment" class="con_item environment">
            <div class="item_tit">学习生活环境</div>
            <div class="details_box">
              <div class="item" v-for="(item, index) in imgList" :key="index">
                <div class="title">{{ item.title }}</div>
                <div class="img_box">
                  <div v-for="(item1, index1) in item.list" :key="index1">
                    <!-- <img :src="item1.url" alt="" /> -->
                    <el-image style="width: 100%; height: 100%" :src="item1.url" fit="cover" :preview-src-list="bigImgLIst"></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="员工福利">
          <div id="welfare" class="con_item welfare">
            <div class="item_tit">员工福利</div>
            <div class="details_box">
              <img src="../assets/trainingCamp/welfare.png" alt="" />
            </div>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="招聘职位">
          <div id="join_us" class="con_item join_us">
            <div class="item_tit">招聘职位</div>
            <div class="join_con">
              <div class="item" v-for="(item, index) in joinList" :key="index">
                <div class="title">{{ item.title }}</div>
                <div class="join_html" v-html="item.content"></div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="联系我们">
          <div id="contact_us" class="con_item contact_us">
            <div class="item_tit">联系我们</div>
            <div class="contact_con" v-if="talkData">
              <div class="contact_text">
                <span>联系人：</span>
                <span>{{ talkData.contacts }}</span>
              </div>
              <div class="contact_text">
                <span>电话：</span>
                <span>{{ talkData.phone }}</span>
              </div>
              <div class="contact_text">
                <span>邮箱：</span>
                <span>{{ talkData.email }}</span>
              </div>
              <div class="contact_text">
                <span>地址：</span>
                <div class="contact_html" v-html="talkData.address"></div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- end内容 -->
    <Bottom></Bottom>
  </div>
</template>

<script>
import { getRecruitmentList, getTalkUsList } from "@/request/walkInKing.js";
import { problemList } from "@/request/commonProblem.js";
import { getCampNotice, getBanner } from "@/request/trainingCamp.js";
import Noticeontheright from "@/components/Noticeontheright.vue";
import Bottom from "@/components/Bottom.vue";
export default {
  name: "campIntro",
  components: {
    Noticeontheright,
    Bottom,
  },
  data() {
    return {
      imgList: [
        {
          title: "校区环境",
          list: [
            { url: require("@/assets/walkInKing/img/1.jpg") },
            { url: require("@/assets/walkInKing/img/2.jpg") },
            { url: require("@/assets/walkInKing/img/15.jpg") },
          ],
        },
        {
          title: "教学环境",
          list: [
            { url: require("@/assets/walkInKing/img/4.jpg") },
            { url: require("@/assets/walkInKing/img/5.jpg") },
            { url: require("@/assets/walkInKing/img/3.jpg") },
          ],
        },
        {
          title: " 住宿环境",
          list: [
            { url: require("@/assets/walkInKing/img/6.jpg") },
            { url: require("@/assets/walkInKing/img/7.jpg") },
            { url: require("@/assets/walkInKing/img/8.jpg") },
          ],
        },
        {
          title: "餐饮环境",
          list: [
            { url: require("@/assets/walkInKing/img/9.jpg") },
            { url: require("@/assets/walkInKing/img/10.jpg") },
            { url: require("@/assets/walkInKing/img/11.jpg") },
          ],
        },
      ],
      bigImgLIst: [
        require("@/assets/walkInKing/img/1.jpg"),
        require("@/assets/walkInKing/img/2.jpg"),
        require("@/assets/walkInKing/img/15.jpg"),
        require("@/assets/walkInKing/img/4.jpg"),
        require("@/assets/walkInKing/img/5.jpg"),
        require("@/assets/walkInKing/img/3.jpg"),
        require("@/assets/walkInKing/img/6.jpg"),
        require("@/assets/walkInKing/img/7.jpg"),
        require("@/assets/walkInKing/img/8.jpg"),
        require("@/assets/walkInKing/img/9.jpg"),
        require("@/assets/walkInKing/img/10.jpg"),
        require("@/assets/walkInKing/img/11.jpg"),
      ],
      noticeList: {},
      joinList: [],
      talkData: {},
      problemList: [],
      bannerList: [],
    };
  },
  mounted() {
    this.getdata();
    this.getCampNotice();
    this.getRecruitmentList();
    this.getTalkUsList();
    this.getBanner(6);
  },
  methods: {
    async getdata() {
      let params = { experienceType: 2 };
      const res = await problemList(params);
      if (res.code == 200) {
        this.problemList = res.data.list;
      }
    },
    // 报名须知
    async getCampNotice() {
      const res = await getCampNotice();
      if (res.code == 200) {
        this.noticeList = res.data;
      }
    },
    // 招聘职位数据
    async getRecruitmentList() {
      const res = await getRecruitmentList(1);
      if (res.code == 200) {
        this.joinList = res.data;
      }
    },
    async getTalkUsList() {
      const res = await getTalkUsList(this.joinNavAct);
      if (res.code == 200) {
        this.talkData = res.data[0];
      }
    },
    async getBanner(type) {
      const res = await getBanner(type);
      if (res.code == 200) {
        this.bannerList = res.data;
      }
    },
    // 去就业数据
    toJob(type) {
      this.$router.push({
        name: "employmentData",
        params: { languageType: type },
      });
    },
    toUrl(url) {
      if (!url) return;
      window.open(url);
    },
  },
};
</script>
<style>
.el-image-viewer__img {
  max-height: 70% !important;
  max-width: 70% !important;
}
</style>
<style>
/* 选项卡 */
.el-tabs--left .el-tabs__header.is-left {
  padding: 20px 0 0 0;
  background: #ffffff;
  box-shadow: -2px 0px 15px 0px rgba(138, 127, 255, 0.15);
  border-radius: 16px;
  margin: 5px 20px 10px 10px;
}
.el-tabs__nav-wrap::after {
  content: none;
}
.el-tabs__active-bar {
  display: none;
}
.el-tabs--left .el-tabs__item.is-left {
  text-align: center;
}
.el-tabs__item {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  padding: 0 20px;
}
.el-tabs__item:hover {
  color: #7078fb;
}
.el-tabs__item.is-active {
  color: #7078fb;
}
.environment .el-image {
  transition: transform 0.3s ease-in;
}
.environment .el-image:hover {
  transform: scale(1.1);
}
</style>
  
<style scoped>
.Walkintothekingsway {
  margin-top: 70px;
  background: url("../assets/trainingCamp/wrap_bg.png") no-repeat;
  background-size: 100%;
  background-position-y: 600px;
}
.content {
  width: 1200px;
  margin: 60px auto;
}
.title20 {
  font-size: 20px;
  font-family: Noto Sans S Chinese;
  font-weight: bold;
  color: #404040;
}
.banner {
  width: 100%;
  min-width: 1200px;
  height: 500px;
}
/* 标题 */
.con_item .item_tit {
  font-size: 22px;
  font-family: Noto Sans S Chinese;
  font-weight: bold;
  color: #404040;
  position: relative;
  margin-bottom: 50px;
}
.con_item .item_tit::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 66px;
  height: 3px;
  background: #7466ff;
}
/* 报名前必读须知  */

/* 必读须知 */
.notice .details_box {
  box-shadow: 0px 2px 10px 0px rgba(147, 147, 147, 0.15);
  border-radius: 10px;
  margin: 5px;
  overflow: hidden;
}
.notice .intro {
  padding: 30px 35px;
}
.notice .intro .title {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 10px;
}
.notice .intro .text {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 28px;
}
.notice .problem .title {
  padding: 10px 50px 10px 30px;
  background: #f5f5f5;
  border-radius: 0px 10px 10px 0px;
  display: inline-block;
  font-size: 16px;
  font-family: Noto Sans S Chinese;
  font-weight: 500;
  color: #404040;
  margin-bottom: 20px;
}
.notice .problem .text {
  margin-bottom: 30px;
  background: #f5f5f5;
  padding: 15px 30px;
  font-size: 14px;
  font-family: Noto Sans S Chinese;
  font-weight: 500;
  color: #4d4d4d;
  line-height: 30px;
}
/* 生活环境 */
.environment .item {
  margin-bottom: 30px;
}
.environment .item .title {
  font-size: 18px;
  font-family: Noto Sans S Chinese;
  font-weight: bold;
  color: #404040;
  margin-bottom: 15px;
}
.environment .item .img_box {
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
}
.environment .item .img_box > div {
  width: calc(33% - 10px);
  height: 140px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(153, 153, 153, 0.34);
}

/* 员工福利 */
.welfare .details_box img {
  width: 100%;
}
/* 招聘职位 */
.join_us .item {
  margin-bottom: 60px;
  cursor: pointer;
}
.join_us .join_con {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
}
.join_us .join_con .item {
  border-bottom: 1px solid #e6e6e6;
  padding: 30px 25px;
}
.join_us .join_con .item:last-child {
  border-bottom: none;
}
.join_us .join_con .item .title {
  font-size: 18px;
  font-family: Noto Sans S Chinese;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}
.join_html {
  margin-left: 15px;
}
.join_html >>> ul {
  overflow: hidden;
}
.join_html >>> ul li {
  list-style: none;
  position: relative;
  margin: 5px 40px 5px 15px;
  display: inline-block;
}
.join_html >>> ul li::after {
  content: "";
  position: absolute;
  top: 7px;
  left: -15px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ada4ff;
}

/* 联系我们 */

.contact_us .contact_con {
  padding: 30px 20px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
}
.contact_us .contact_con .contact_text {
  margin-bottom: 10px;
  font-size: 17px;
  display: flex;
  align-content: center;
}
.contact_us .contact_con .contact_text span:first-child {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  width: 80px;
  text-align: right;
}
.contact_us .contact_con .contact_text .contact_html {
  display: inline-block;
}
</style>
